/*<!-- ============================================================================= -->
<!-- Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->*/

$(document).ready(function() {
  $('[data-open-sidebar]').on('click', function() {
    $('.page-sidebar, .page-content').toggleClass('sidebar-open');
    $(this).find('.text').text($('.page-sidebar').hasClass('sidebar-open') ? 'Ocultar Filtros' : 'Mostrar Filtros');
  });

  function copyToClipboard(element) {
    var $temp = $("<input>");
    var oldValue = $(element).html();

    $("body").append($temp);
    $temp.val($(element).children("span").html()).select();

    async function copyTextToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    }
    copyTextToClipboard(oldValue);

    $(element).html("COPIADO");
    setTimeout(function () {
        $(element).html(oldValue);
    }, 1000);
    $temp.remove();
  }

  $("cupom").click(function () {
      copyToClipboard(this);
  });
});


function error_ship_ajax(msg) {
  $(".erro-shipping").text(msg).slideDown();

  setTimeout(function () {
    $(".erro-shipping").slideUp();
  }, 5000);
}

// UPSELL Carrinho
window.upsellSliderInit = function(){
  var upsellCartSlider = new Swiper(".recommend-slider", {
    slidesPerView: "auto",
    spaceBetween: 15,
    slidesPerGroup: 3,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true
    }
  });
}
function beforeSend() {
  $('#dropdown-cart').addClass('updating-cart');
}
function afterSend() {
  $('#dropdown-cart').removeClass('updating-cart');
}
$(document).on('submit', '.upsell-form', function(e) {
  e.preventDefault();

  const formData = new FormData(this);
  const serializedData = {};
  formData.forEach((value, key) => {
    serializedData[key] = value;
  });
  const jsonData = JSON.stringify(serializedData);

  // URL da API da Shopify para adicionar um item ao carrinho
  const addToCartUrl = window.Shopify.routes.root + 'cart/add.js';

  // Opções da requisição
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: jsonData,
  };

  beforeSend(); // Ação "before send" antes da requisição

  // Faz a requisição usando fetch com ação "before send" e "after send"
  fetch(addToCartUrl, requestOptions)
    .then((response) => {
      afterSend(); // Ação "after send" após a conclusão da requisição

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui
      window.updateCart();
    })
    .catch((error) => {
      // Houve um erro na requisição, você pode tratar o erro aqui
      console.error('Error:', error);
    });
});
$(document).on('change', '.variants-product-selects select', function() {
  var $currentSelect = $(this);
  var $nextSelect = $currentSelect.closest('.variants-product-selects').find('select').eq($currentSelect.index() + 1);
  var productData = JSON.parse($currentSelect.closest('.infoProduct').find('[data-json-product]').text());

  const availableVariants = productData.filter(variant => variant.title.includes($currentSelect.val()) && variant.available);

  if ($nextSelect.length) {
    $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', true);
    nextSelectName = $nextSelect.data('name');
    $nextSelect.html(`<option disabled="" selected="">${nextSelectName}</option>`);
    const nextSelectIndex = $nextSelect.data('index');
    availableVariants.forEach(variant => {
      $nextSelect.append(`<option value="${variant[nextSelectIndex]}">${variant[nextSelectIndex]}</option>`)
    })
  }
  
  if ($nextSelect.length && $nextSelect.is(':hidden')) {
      $nextSelect.show();
  } else if (!$nextSelect.length) {
      var selectedOptions = $currentSelect.closest('.variants-product-selects').find('select').map(function() { return $(this).val(); }).get();
      var productData = JSON.parse($currentSelect.closest('.infoProduct').find('[data-json-product]').text());
      
      var matchingVariant = productData.find(function(variant) {
          return selectedOptions.every(function(option, index) {
              return variant.options[index] === option;
          });
      });

      if (matchingVariant && matchingVariant.available) {
          $currentSelect.closest('.infoProduct').find('.variantIdAddCart').val(matchingVariant.id);
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', false);
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').val('ADICIONAR');
      } else {
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', true);
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').val('ESGOTADO');
          console.log('Produto esgotado');
      }
  }

  var container = $('.halo-cart-sidebar').find('.previewCart');
  var scrollTo = $('.halo-cart-sidebar').find('.recommend-container');
  
  // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
  var scrollPosition = scrollTo.offset().top + scrollTo.outerHeight() + container.scrollTop() - container.position().top;
  
  // Realiza a rolagem
  container.animate({
      scrollTop: scrollPosition
  }, 1000); // 1000 milissegundos para a animação de rolagem
});

// END UPSELL Carrinho

// Cart Shipping

function shipping_ajax() {
    var $input_cep = $(".zipcode-input"),
      $btn_calc = $(".calculate-shipping"),
      $shipping_list = $(".shipping_options__list"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $container_ship_name = $(".shipping-rate-name");

    // $btn_calc.addClass("is-loading");
    toggleButtonState($btn_calc, true);
    var $cep = $input_cep.val().replace(/\D/g, "");
    var $validacep = /^[0-9]{8}$/;

    console.log($validacep.test($cep));
    if ($cep == "") {
      error_ship_ajax("Campo cep está vazio");
      // $btn_calc.removeClass("is-loading");
      toggleButtonState($btn_calc, false);
      return;
    }

    if (!$validacep.test($cep)) {
      error_ship_ajax("Cep inválido");
      toggleButtonState($btn_calc, false);
      return;
    }

    function isDateBeforeToday(date) {
      return (
        new Date(date.toDateString()) < new Date(new Date().toDateString())
      );
    }

    function excludeDate(name) {
      var response =
        name !=
          "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis" &&
        name != "Entrega Rápida - pedidos chegam em até 48hrs úteis";
      return response;
    }

    $.getJSON(
      "https://viacep.com.br/ws/" + $cep + "/json/?callback=?",
      function (dados) {
        if ("erro" in dados) {
          error_ship_ajax("Erro na consulta, confira o cep e tente novamente");
          toggleButtonState($btn_calc, false);
          return;
        }

        switch (dados.uf) {
          case "AC":
            dados.uf = "Acre";
            break;
          case "AL":
            dados.uf = "Alagoas";
            break;
          case "AP":
            dados.uf = "Amapa";
            break;
          case "AM":
            dados.uf = "Amazonas";
            break;
          case "BA":
            dados.uf = "Bahia";
            break;
          case "CE":
            dados.uf = "Ceara";
            break;
          case "DF":
            dados.uf = "Distrito Federal";
            break;
          case "ES":
            dados.uf = "Espirito Santo";
            break;
          case "GO":
            dados.uf = "Goias";
            break;
          case "MA":
            dados.uf = "Maranhao";
            break;
          case "MT":
            dados.uf = "Mato Grosso";
            break;
          case "MS":
            dados.uf = "Mato Grosso do Sul";
            break;
          case "MG":
            dados.uf = "Minas Gerais";
            break;
          case "PA":
            dados.uf = "Para";
            break;
          case "PB":
            dados.uf = "Paraiba";
            break;
          case "PR":
            dados.uf = "Parana";
            break;
          case "PE":
            dados.uf = "Pernambuco";
            break;
          case "PI":
            dados.uf = "Piaui";
            break;
          case "RJ":
            dados.uf = "Rio de Janeiro";
            break;
          case "RN":
            dados.uf = "Rio Grande do Norte";
            break;
          case "RS":
            dados.uf = "Rio Grande do Sul";
            break;
          case "RO":
            dados.uf = "Rondonia";
            break;
          case "RR":
            dados.uf = "Roraima";
            break;
          case "SC":
            dados.uf = "Santa Catarina";
            break;
          case "SP":
            dados.uf = "Sao Paulo";
            break;
          case "SE":
            dados.uf = "Sergipe";
            break;
          case "TO":
            dados.uf = "Tocantins";
            break;
        }

        $.ajax({
          type: "GET", //rest Type
          dataType: "json", //mispelled
          url:
            "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" +
            $cep +
            "&shipping_address%5Bcountry%5D=" +
            "Brazil" +
            "&shipping_address%5Bprovince%5D=" +
            dados.uf,
          beforeSend: function () {
            //$('.overlay-carregando').show();
          },
          success: function (msg) {
            $shipping_list.html("");
            // $ship_name_display.html(msg.shipping_rates[0].name);
            // if($('.shipping-display.value') === 0.00){
            //   $('.shipping-display.value').html("Grátis");
            // }else{
            //   $('.shipping-display.value').html(Shopify.formatMoney(msg.shipping_rates[0].price, window.money_format));
            // }
            console.log(msg.shipping_rates);
            for (i = 0; i < msg.shipping_rates.length; i++) {
              var deliveryDate = msg.shipping_rates[i].delivery_date;

              var entrega = new Date(msg.shipping_rates[i].delivery_date);
              var checkBeforeday = isDateBeforeToday(entrega);
              var excludeDateCheck = excludeDate(msg.shipping_rates[i].name);
              let dataFormatada =
                entrega.getDate() +
                "/" +
                (entrega.getMonth() + 1) +
                "/" +
                entrega.getFullYear();

              let $formatedPrice;
              let $estimateShip;
              if (msg.shipping_rates[i].price === 0.0) {
                $formatedPrice = "Grátis";
              } else {
                $formatedPrice = Shopify.formatMoney(
                  msg.shipping_rates[i].price,
                  window.money_format
                );
              }
              var $priceShip = msg.shipping_rates[i].price;
              if (
                msg.shipping_rates[i].delivery_days[1] == null ||
                msg.shipping_rates[i].delivery_days[1] === 0
              ) {
                $estimateShip = "";
              } else {
                $estimateShip =
                  "Em até " +
                  msg.shipping_rates[i].delivery_days[1] +
                  " dias úteis";
              }

              if (
                (deliveryDate == null && excludeDateCheck) ||
                (checkBeforeday && excludeDateCheck)
              ) {
                entrega = "Estimativa de entrega indisponível";
              } else if (!excludeDateCheck) {
                if (
                  d.shipping_rates[i].name ==
                  "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis"
                ) {
                  entrega = "";
                } else {
                  entrega = "";
                }
              } else {
                entrega = "<br/>(Estimativa de entrega: " + dataFormatada + ")";
              }
              // else {
              //   entrega = "";
              // }

              var $template =
                '<li data-shipping-change class="filters-group__list__item"> <label for="shipping-option_' +
                msg.shipping_rates[i].name
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "") +
                '" class="filters-checkbox"> <input type="radio" name="shipping_id" value="shippingId" id="shipping-option_' +
                msg.shipping_rates[i].name
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "") +
                '" data-name="' +
                msg.shipping_rates[i].name +
                '" data-price="' +
                msg.shipping_rates[i].price +
                '" data-formatted-price="' +
                $formatedPrice +
                '" data-delivery="' +
                $estimateShip +
                '"> <span class="check"></span> <span class="text" style="display: block;">' +
                msg.shipping_rates[i].name +
                " - " +
                $formatedPrice +
                " " +
                //entrega +
                "(" +
                $estimateShip +
                ")" +
                "</span> </label> </li>";

              $shipping_list.append($template);
              console.log($shipping_list);
              console.log($template);

              //$("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", msg.shipping_rates[i].price);
              // $btn_calc.removeClass("is-loading");
              toggleButtonState($btn_calc, false);
            }
            // $display_shipping.removeClass('hidden');
            // $ship_name_display.removeClass('hidden');
            $shipping_list_container.removeClass("hidden");
          },
          error: function (erro) {
            error_ship_ajax("Não encontrou um frete?");
            // $btn_calc.removeClass("is-loading");
            toggleButtonState($btn_calc, false);
          },
        });
      }
    );
  }

  function select_ship(selected) {
    var name = selected.data("name"),
      price = selected.data("price"),
      formated_price = selected.data("formatted-price"),
      delivery = selected.data("delivery");

    var $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $ship_price_display = $(".shipping-display.value"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping");

    $ship_name_display.html(name);
    $ship_price_display.html(formated_price);

    $display_shipping.removeClass("hidden");
    $ship_name_display.removeClass("hidden");
    $shipping_list_container.addClass("hidden");
    $btn_calc.addClass("hidden");
    $btn_change.removeClass("hidden");
  }

  function show_rate_list() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options");
    $shipping_list_container.removeClass("hidden");
  }

  function reset_ship() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping"),
      $input_cep = $(".zipcode-input");

    $shipping_list_container.addClass("hidden");
    $display_shipping.addClass("hidden");
    $btn_change.addClass("hidden");
    $btn_calc.removeClass("hidden");
    $input_cep.val("").focus();
  }

function toggleButtonState(button, isLoading) {
  if (isLoading) {
    button.addClass("is-loading");
    button.prop("disabled", true);
  } else {
    button.removeClass("is-loading");
    button.prop("disabled", false);
  }
}


  $(document).on("click", ".calculate-shipping", function (e) {
    if(!$(this).hasClass("is-loading"))
      shipping_ajax();
  });

  $(document).on("click", ".recalculate-shipping", function (e) {
    reset_ship();
  });

  $(document).on("click", "[data-shipping-change]", function (e) {
    select_ship($(this).find("input"));
  });

  $(document).on("click", ".show-rates-list", function (e) {
    show_rate_list();
  });

  // END CART Shipping

window.handleize = function (input) {
  return input
    // 1. Decompose accented letters into letter + diacritic mark
    .normalize("NFD")
    // 2. Toss out the diacritic marks
    .replace(/[\u0300-\u036f]/g, "")
    // 3. Lower-case everything
    .toLowerCase()
    // 4. Trim leading/trailing space
    .trim()
    // 5. Remove everything except letters, numbers, spaces, and dashes
    .replace(/[^a-z0-9\s-]/g, "")
    // 6. Replace groups of whitespace with a single dash
    .replace(/\s+/g, "-")
    // 7. Collapse multiple dashes (in case input had "--" etc.)
    .replace(/-+/g, "-");
}


function formatCep(value) {
    return value
        .replace(/\D/g, '')
        .slice(0, 8)
        .replace(/^(\d{5})(\d{0,3})$/, (_, p1, p2) => p2 ? `${p1}-${p2}` : p1);
}

function isValidCep(value) {
    return /^\d{5}-\d{3}$/.test(value);
}

function formatPhone(value) {
    return value
        .replace(/\D/g, '')
        .slice(0, 11)
        .replace(/^(\d{2})(\d{0,5})(\d{0,4})$/, (_, ddd, p1, p2) => p2 ? `(${ddd}) ${p1}-${p2}` : p1 ? `(${ddd}) ${p1}` : `(${ddd}`);
}

function applyMask(target, formatter) {
    // Salva o estado do cursor para evitar o salto para o final
    const start = target.selectionStart;
    const previousLength = target.value.length;

    target.value = formatter(target.value);

    // Reposiciona o cursor adequadamente
    const lengthDiff = target.value.length - previousLength;
    const newPosition = Math.max(0, start + lengthDiff);
    target.setSelectionRange(newPosition, newPosition);
}

document.addEventListener('input', ({ target }) => {
    if (target.matches('.zipcode-input') || target.matches('.cep-calculo-frete')) {
        applyMask(target, formatCep);
    } else if (target.matches('.contact-phone')) {
        applyMask(target, formatPhone);
    }
});

document.addEventListener('focusout', ({ target }) => {
    if (!target.matches('.zipcode-input')) return;

    if (target.value && !isValidCep(target.value)) {
        error_ship_ajax('CEP inválido');
    }
});